import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  getContractAgreements() {
    return defaultClient.get('/contracts/agreements/')
  },
  getContractCurrent() {
    return defaultClient.get('/contracts/current/')
  },
  getContractTerms() {
    return defaultClient.get('/contracts/terms/')
  },
  getContractAgreementsLimitTransaction() {
    return defaultClient.get('/contracts/agreements/limit-transaction/')
  },
  postContractComplete() {
    return defaultClient.post('/contracts/complete/')
  },
  /**
   *
   * @param {
   *  code : "CODE"
   * } query
   * @returns
   */
  getContractTermsCode(query) {
    return defaultClient.get(`/contracts/terms/code/?${qs.stringify(query)}`)
  },
  postContractTermAgree(term) {
    return defaultClient.post(`/contracts/terms/${term.uuid}/agree/`)
  },
  postContractTermDisagree(term) {
    return defaultClient.post(`/contracts/terms/${term.uuid}/disagree/`)
  },
  /**
   *
   * @param {
   *  contract: uuid
   *  term: uuid
   *  isAgreed: boolean
   *  signature: binary // 강제변환
   *  image: binary // 강제변환
   * } data
   * @returns
   */
  postContractAgreements(data) {
    const formData = new FormData()
    for (const k in data) {
      if (k === 'signature') {
        formData.append(k, data[k], 'signature.png')
      } else if (k === 'image') {
        formData.append(k, data[k], 'image.png')
      } else {
        formData.append(k, data[k])
      }
    }
    return defaultClient.post('/contracts/agreements/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getContractsAgreementsMyfinbizService() {
    return defaultClient.get('/contracts/agreements/myfinbiz-service/')
  },
}
